// src/app/modules/capitalShare/redux/service.ts
import axios from 'axios'
import moment from 'moment'
import * as mock from './mockService'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
const MODULE = 'capital-market-service'

// ── Toggle this to false when the real API is ready ───────────────────────────
const MOCK_MODE = true

// ── CBS lookup ──────────────────────────────────────────────────────────────────
// CBS is a separate core-banking system; swap this URL for the real CBS base URL
// when the sandbox is available. Keep as-is for development/staging.
const MOCK_CBS_CUSTOMER = {
  account_number: '',
  account_name: 'Suresh Kumar Shrestha',
  cif_number: 'CIF-123456-5678',
  gender: 'Male',
  date_of_birth: '04/12/1988',
  father_name: 'Ram Bahadur Shrestha',
  mother_name: 'Sita Devi Shrestha',
  grandfather_name: 'Hari Bahadur Shrestha',
  email: 'suresh.shrestha@example.com',
  mobile: '+971-50-1234567',
  citizenship_no: '12-01-78-09876',
  issue_district: 'Kathmandu',
  issued_date: '2065-03-14',
  permanent_address: 'Ward 5, Kathmandu Metropolitan City, Bagmati',
  local_address: 'Apt 12B, Al Barsha, Dubai, UAE',
  source_of_income: 'Salary',
  company: 'Emirates Logistics LLC',
  annual_income: 4800000,
  pan_number: '605678543',
  account_status: 'Active' as const,
}

export const cbsAccountLookup = (account_number: string) => {
  // TODO: return axios.post(`${CBS_BASE_URL}/account-lookup`, { account_number })
  const isDormant = account_number.endsWith('0000')
  const isInvalid = account_number.length !== 16
  if (isInvalid) return Promise.reject(new Error('Account not found in CBS'))
  return Promise.resolve({
    data: {
      ...MOCK_CBS_CUSTOMER,
      account_number,
      account_status: isDormant ? 'Dormant' : 'Active',
    },
  })
}

// ── Application list — GET /case-reports ────────────────────────────────────────
export const fetchApplicationList = (params: any) => {
  // if (MOCK_MODE) return mock.mockFetchApplicationList(params)
  const {fromDate, toDate, queue, ...rest} = params
  const queryParams = {
    ...rest,
    module: MODULE,
    queue,
    from_date: fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined,
    to_date: toDate ? moment(toDate).format('YYYY-MM-DD') : undefined,
  }
  return axios.get(`${API_URL}/list/${queryParams?.module}/${params?.step}`, {params: queryParams})
}

// ── Form submission — POST /submit/:module/:step ────────────────────────────────
export const submitApplication = (data: any, step: string) => {
  // if (MOCK_MODE) return mock.mockSubmitApplication(data, step)
  return axios.post(`${API_URL}/submit/${MODULE}/${step}`, data)
}

// ── Fetch single case — GET /case-reports/:case_id ─────────────────────────────
export const fetchCase = (case_id: string) => {
  // if (MOCK_MODE) return mock.mockFetchCase(case_id)
  return axios.get(`${API_URL}/case-reports/${case_id}`, {params: {module: MODULE}})
}

// ── Checker action — POST /case-reports/:case_id/review ────────────────────────
export const checkerAction = (action: string, case_id: string, remarks: string) => {
  // if (MOCK_MODE) return mock.mockCheckerAction(action, case_id, remarks)
  return axios.post(`${API_URL}/case-reports/${case_id}/review`, {action, remarks, module: MODULE})
}

// ── Fee config ──────────────────────────────────────────────────────────────────
export const fetchFeeConfig = () => axios.get(`${API_URL}/capital-market-service/fee-config`)

export const updateFeeConfig = (config: any) =>
  axios.post(`${API_URL}/capital-market-service/fee-config`, config)
